export default __webpack_public_path__ + "static/media/BML_Logo_srgb.bb8511ce.svg";